import React, { Component } from "react";
import { connect } from "react-redux";
import { Button } from "antd";

import { Header, Nav, HamburgerMenu } from "./components";

import { loginUserCheck, logoutUser, spareBrandCreate } from "../redux/actions";

class AdminAddSpareBrand extends Component {
  constructor() {
    super();
    this.state = {
      photo: "",
      title: "",
      toggleMenu: false,
    };
  }

  componentWillMount() {
    this.props.loginUserCheck();
  }

  _handleMenu() {
    this.setState({ toggleMenu: !this.state.toggleMenu });
  }

  _handleLogout() {
    this.props.logoutUser();
  }

  _onHandleChange(event) {
    if (event.target.files) {
      this.setState({
        [event.target.name]: event.target.files[0],
      });
    } else {
      this.setState({
        [event.target.name]: event.target.value,
      });
    }
  }

  _onSubmit() {
    let data = {
      brand_id: new Date().getTime(),
      img: this.state.photo,
      title: this.state.title,
      order: 1,
      created_by: this.props.user,
      created_date: new Date().getTime(),
      updated_date: new Date().getTime(),
    };
    if (this.state.photo && this.state.title) {
      this.props.spareBrandCreate(data);
    } else {
      alert("Please fill in a form...");
    }
  }

  render() {
    if (!this.props.user) return <div></div>;
    return (
      <div>
        <Header name={this.props.user} logout={() => this._handleLogout()} />
        <div className="admin-addbrand">
          <Nav active="spare" />
          <div
            className={this.state.toggleMenu ? "content moveover" : "content"}
          >
            <div className="content-inner">
              <HamburgerMenu onClick={() => this._handleMenu()} />
              <div className="title">
                <h2>อะไหล่ : เพิ่มยี่ห้อ</h2>
              </div>
              <div className="info">
                <div className="adjust">
                  <form action="" className="photo">
                    <div className="brand-title">
                      <p>โลโก้ยี่ห้อ (320x235px)</p>
                    </div>
                    <div className="filename">
                      <p>{this.state.photo.name}</p>
                    </div>
                    <div className="photo-input">
                      <input
                        id="photo"
                        type="file"
                        name="photo"
                        accept="image/*"
                        hidden
                        onChange={(event) => this._onHandleChange(event)}
                      />
                      <label htmlFor="photo">เลือกรูปภาพ</label>
                    </div>
                  </form>
                  <form className="text">
                    <p>ชื่อยี่ห้อ</p>
                    <input
                      type="text"
                      name="title"
                      onChange={(event) => this._onHandleChange(event)}
                    ></input>
                  </form>
                  <div className="action-button">
                    {this.props.loading ? (
                      <div>
                        <p style={{ textAlign: "left" }}>Loading...</p>
                      </div>
                    ) : (
                      <div>
                        <Button type="primary" onClick={() => this._onSubmit()}>
                          บันทึก
                        </Button>
                        <Button onClick={() => window.history.back()}>
                          กลับ
                        </Button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ auth, brand }) => {
  return {
    user: auth.user,
    loading: brand.loading,
  };
};

export default connect(mapStateToProps, {
  loginUserCheck,
  logoutUser,
  spareBrandCreate,
})(AdminAddSpareBrand);
